/*
 *
 * RubiconePromoCarouselPopup
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 25-Aug-2025
 */

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  titlePage: (promoType) => (
    <PortalMessage
      id='t.app.rubicone.popup.promo.titlePage'
      values={{ promoType }}
      defaultMessage='Scopri l’offerta {promoType}'
    />
  ),
  titlePos: (price) => (
    <PortalMessage
      id='t.app.rubicone.popup.promo.titlePos'
      values={{ price }}
      defaultMessage='Canone a {price}€ al mese e commissioni vantaggiose'
    />
  ),
  descPos: (
    <PortalMessage
      id='t.app.rubicone.popup.promo.descPos'
      defaultMessage='Sottoscrivi un nuovo contratto e ottieni Nexi SmartPOS® Mini con stampante a condizioni eccezionali.'
    />
  ),
  titleCashback: (perc) => (
    <PortalMessage
      id='t.app.rubicone.popup.promo.titleCashback'
      values={{ perc }}
      defaultMessage='Cashback di {perc}% sul totale del transato mensile'
    />
  ),
  descCashback: (promoType) => (
    <PortalMessage
      id='t.app.rubicone.popup.promo.descCashback'
      values={{ promoType }}
      defaultMessage='Con la {promoType} raggiungi il tuo obiettivo di transato e sblocca il cashback.'
    />
  ),
  discoverMore: <PortalMessage id='t.app.rubicone.popup.promo.discoverMore' defaultMessage='Scopri di più' />
}
export default formattedMessage
